import { GridPosition } from './grid-position';

export class Block {
  public get id() {
    return `${this.posInShape.row}${this.posInShape.col}`;
  }
  public readonly posInShape: GridPosition;
  public multiplier = 0;

  constructor(posInShape: GridPosition) {
    this.posInShape = posInShape;
  }
}
